"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var user_store_1 = require("../../reverb-js-common/user_store");
var url_helpers_1 = require("./url_helpers");
// Appends the user's country code to a given URL
// i.e. /marketplace/electric-guitars -> /uk/marketplace/electric-guitars
exports.default = (function (url) {
    var countryCode = user_store_1.default.getState().countryCode;
    return url_helpers_1.default.urlByRegion(url, countryCode);
});
//# sourceMappingURL=user_region_url.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/user_region_url.js
// module id = I3Id
// module chunks = 20 21